/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface ErrorsSignature {
  Element: HTMLDivElement;
  Args: {
    errors?: Record<string, any>[];
    removeError: (error: Record<string, any>) => unknown;
  };
}

export default class Errors extends Component<ErrorsSignature> {
  get sortedErrors() {
    return this.args.errors?.sort((error1, error2) => {
      let updated2 = error2?.updated ?? 0;
      let updated1 = error1?.updated ?? 0;

      return updated2 - updated1;
    });
  }
}
